import { Component, ViewChild, OnInit } from '@angular/core';

import { GlobalState } from '../../../global.state';

import 'style-loader!./baPageTop.scss';
import { AuthService } from "../../../common/services/permission/authService.service";
import { Router } from "@angular/router";
import { MasterRepo } from '../../../common/repositories';
import { AppState } from '../../../app.service';
import { TTLCacheService } from 'src/app/common/services/cache.service';
import { StateService } from 'src/app/common/services/state.service';

@Component({
  selector: 'ba-page-top',
  templateUrl: './baPageTop.html',
  styleUrls: ['./baPageTop.scss'],
})
export class BaPageTop implements OnInit {
  @ViewChild('notificationAudio') notificationAudio: any;
  hasNewNotification = false;
  showLogoutModal: boolean = false;
  public isScrolled: boolean = false;
  public isMenuCollapsed: boolean = false;
  user: string;
  smsCredits: number;
  EnableTreatment: boolean;
  EnableAppointment: boolean;
  constructor(private _state: GlobalState
    , private _authService: AuthService
    , private appService: AppState
    , private router: Router
    , private cache: TTLCacheService
    , private stateService: StateService
    , private service: MasterRepo) {
    var setting = _authService.getSetting();
    this.EnableTreatment = setting.EnableTreatment;
    this.EnableAppointment = setting.EnableAppointment;
    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
      this.isMenuCollapsed = isCollapsed;
    });
    if (_authService.getUserProfile()) {
      this.user = _authService.getUserProfile().UserId;
    }
    this.getSmsCredit();
  }

  ngOnInit(): void {
    this.appService.notification$.subscribe(data => {
      if(data.nType == 0){
        this.hasNewNotification = true;
        this.playNotificationSound();
      }
    });
  }

  playNotificationSound() {
    if (this.notificationAudio && this.notificationAudio.nativeElement) {
      this.notificationAudio.nativeElement.play().catch((err) => console.warn('Audio play failed:', err));
    }
  }

  clearNotification() {
    this.hasNewNotification = false;
  }

  getSmsCredit() {
    this.service.getSmsCredit().subscribe(
      (data:any) => {
        if(data.result)
          this.smsCredits = data.result.credits_available;  
      },

      (err) => console.log(err)
    )

  }

  public toggleMenu() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    this._state.notifyDataChanged('menu.isCollapsed', this.isMenuCollapsed);
    return false;
  }
    
  openLogoutModal() {
    this.showLogoutModal = true;
  }
  
  closeLogoutModal() {
    this.showLogoutModal = false;
  }
    
  logout() {
    this._authService.removeAuth();
    this.cache.clearAll();   
    this.router.navigate(['/login']);
    this.closeLogoutModal();
    this.stateService.clearStateData();
  }

  changePassword() {
    this.router.navigate(['change-password']); 
    this.closeLogoutModal();
  }

  public scrolledChanged(isScrolled) {
    this.isScrolled = isScrolled;
  }
}
